var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWaterproof = function SvgWaterproof(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M14.75 14c0 4.142-2.608 6.75-6.75 6.75S1.25 18.142 1.25 14c0-4.445 4.839-10.446 6.323-12.182a.563.563 0 0 1 .854 0C9.912 3.554 14.75 9.555 14.75 14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12.125 14.375A3.375 3.375 0 0 1 8.75 17.75"
  })));
};
export default SvgWaterproof;